import React, { useState } from "react";
import {
  ChevronsUpDown,
  Filter,
  ChevronLeft,
  ChevronRight,
  Search,
} from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";

export default function CustomTable({
  data,
  columns,
  showSortIcon = false,
  pageIndex,
  pageSize,
  setPageIndex,
  globalFilter,
  setGlobalFilter,
  fetchUsers,
  pageCount,
  pageData,
}) {
  const navigate = useNavigate();
  const location = useLocation();

  console.log("paginatedData____", pageData);
  return (
    <div>
      {/* Search Input */}
      <div className="flex justify-between gap-[21px] mb-8 mt-4">
        <div className="relative search-filter-gradient flex items-center gap-2 w-[378px] h-10 pr-4 pl-4 py-2 rounded-lg">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-[#A0A0A0] w-4 h-4" />
          <input
            className="bg-transparent pl-5 outline-none text-[#F6F6F6] text-[12px] w-full placeholder-[#F6F6F6]"
            placeholder="Search"
            value={globalFilter}
            onChange={(e) => {
              setGlobalFilter(e.target.value);
            }}
          />
        </div>

        {location.pathname === "/manage-user" && (
          <button
            onClick={() => navigate("/manage-user/add")}
            className="bg-[#F3B753] text-black px-6 py-0 rounded-md flex items-center gap-2 font-medium hover:bg-[#e3a840] transition-all"
          >
            Add User
          </button>
        )}
        {/* <button
          className="search-filter-gradient flex flex-row items-center gap-2 w-[99px] h-10 px-6 py-2 rounded-lg box-border"
          type="button"
          onClick={()=>fetchUsers()}
        >
         
          <span className="font-poppins text-xs leading-[18px] text-[#F6F6F6] font-normal">Search</span>
        </button> */}
      </div>

      {/* Table */}
      <div className="overflow-x-auto scrollbar-hide rounded-[8px] w-[1128px] relative">
        <table className="min-w-full text-sm text-left font-poppins relative">
          <thead>
            <tr className="bg-white/20 border border-white/10 border-b-0 h-12">
              {columns.map((col, colIdx) => (
                <th
                  key={col.key}
                  className={`px-4 py-3 font-semibold text-sm text-[#F6F6F6] border-l border-white/10 ${
                    colIdx === 0 ? "border-l-0" : ""
                  }`}
                  style={{ minWidth: col.minWidth, width: col.width }}
                >
                  <div className="flex items-center gap-1">
                    {col.label}
                    {col.showSortIcon && (
                      <ChevronsUpDown className="w-4 h-4 text-[#F6F6F6]" />
                    )}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, idx) => {
              console.log("paginatedData", row);
              return (
                <tr
                  key={idx}
                  className="h-[96px] bg-gradient-to-b from-[#F3B7530A] to-[#EBE9E60A] border-x border-b border-white/10"
                >
                  {columns.map((col, colIdx) => (
                    <td
                      key={col.key}
                      className={`px-4 py-4 text-sm text-[#F6F6F6] border-l border-white/10 ${
                        colIdx === 0 ? "border-l-0" : ""
                      }`}
                    >
                      {col.render
                        ? col.render(row[col.key], row, idx)
                        : row[col.key]}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {pageData?.total_pages > 1 && (
        <div className="flex justify-between items-center mt-8 w-[1139px] relative">
          <span className="text-[#bdbdbd] text-xs font-medium">
            Showing {(pageData?.current_page-1)*pageData?.page_size + 1} to{" "}
            {Math.min((pageData?.current_page ) * pageData?.page_size, pageData?.count)} of {pageData?.count}{" "}
            results
          </span>
          <div className="flex gap-2">
            <button
              className="border border-[#F6F6F6] text-[#F6F6F6] text-sm px-4 py-3 rounded-lg font-semibold flex items-center gap-1 disabled:opacity-50"
              disabled={pageIndex === 1}
             onClick={() => setPageIndex(pageIndex - 1)} 
            >
              <ChevronLeft />
              Previous
            </button>
            <button
              className="border border-[#F6F6F6] text-[#F6F6F6] text-sm px-4 py-3 rounded-lg font-semibold flex items-center gap-1 disabled:opacity-50"
              disabled={pageIndex === pageData.total_pages}
              onClick={() => setPageIndex(pageIndex + 1)}
            >
              Next
              <ChevronRight />
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
